import { motion } from 'framer-motion';
import { useState } from 'react';

const PolicyAuthority = () => {
  const [showModal, setShowModal] = useState(false);

  const authorities = [
    {
      icon: "🏛️",
      name: "海关总署",
      description: "监管执行主体"
    },
    {
      icon: "🏢",
      name: "商务部",
      description: "政策制定部门"
    },
    {
      icon: "💰",
      name: "财政部/税务总局",
      description: "税收政策制定"
    }
  ];

  const policySummary = [
    "国家市场采购贸易方式（代码 1039）",
    "自 2014 年起在全国多地试点并推广",
    "适用于小批量、多品类、无进项出口业务"
  ];

  return (
    <section id="policy-authority" className="py-16 bg-gray-50">
      <div className="max-w-[1440px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-primary mb-4">政策权威背书</h2>
          <p className="text-gray-600 text-lg">合法·国家级·长期存在</p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* 左侧：政策来源标识 */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className="text-xl font-semibold text-primary mb-6">政策制定与监管部门</h3>
            <div className="space-y-4">
              {authorities.map((auth, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="flex items-center gap-4 p-4 bg-white rounded-lg shadow-sm border border-gray-100"
                >
                  <div className="text-2xl">{auth.icon}</div>
                  <div>
                    <h4 className="font-semibold text-primary">{auth.name}</h4>
                    <p className="text-gray-600 text-sm">{auth.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* 右侧：核心政策摘要卡片 */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <div className="bg-white rounded-xl shadow-lg p-8 border-l-4 border-accent">
              <h3 className="text-xl font-semibold text-primary mb-6">核心政策要点</h3>
              <div className="space-y-4">
                {policySummary.map((point, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: 0.6 + index * 0.1 }}
                    className="flex items-start gap-3"
                  >
                    <div className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">{point}</p>
                  </motion.div>
                ))}
              </div>
              
              <button
                onClick={() => setShowModal(true)}
                className="mt-6 text-primary hover:text-primary-dark font-medium text-sm flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                查看政策原文
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      {/* 政策原文弹窗 */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200 flex justify-between items-center">
              <h3 className="text-xl font-semibold text-primary">政策原文参考</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
                <p><strong>海关总署公告2019年第221号</strong></p>
                <p>根据《中华人民共和国海关法》等有关法律法规，海关总署决定在广州等地开展市场采购贸易方式试点...</p>
                <p><strong>商务部等7部门关于加快发展外贸新业态新模式的意见</strong></p>
                <p>支持各地结合实际建设市场采购贸易方式试点，完善相关政策措施...</p>
                <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <p className="text-yellow-800 text-sm">
                    <i className="ri-information-line mr-2"></i>
                    以上为政策摘要，完整政策文件请访问相关部门官方网站查询
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PolicyAuthority;